import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy',
  pure: false,
  standalone: true,
})
export class SortByPipe implements PipeTransform {
  transform<T>(items: T[], sortBy: string): T[] {
    if (!sortBy) return items;
    let val = 1;
    if (sortBy[0] === '-') {
      sortBy = sortBy.substring(1);
      val = -1;
    }
    return items.slice().sort((a, b) => {
      return a[sortBy] > b[sortBy] ? val : -val;
    });
  }
}
